RivalIQ.module('tour', function (tour, App, Backbone, Marionette, $, _, Tour) {

    'use strict';

    // todo: support Backbone/Marionette views for content tour option

    // todo: refactor
    tour.Tour = function (config, options) {

        const fixedClass = (config.fixed ? 'riq-tour-fixed' : '');

        // todo: leverage a view proper, Jade
        const template = [
            `<div class='popover riq-tour ${fixedClass}'>`,
            `<div class='arrow'></div>`,
            `<h3 class='popover-title'></h3>`,
            `<div class='popover-content'></div>`,
            `<div class='popover-navigation'>`,
            `<div class='step-counter'></div>`,
            `<div class='btn-group'>`,
            `<button class='btn btn-default x-big-next' data-role='next'>`,
            'Next',
            `<i class='fa fa-chevron-right'></i>`,
            '</button>',
            `<button class='btn btn-default' data-role='pause-resume' data-pause-text='Pause' data-resume-text='Resume'>Pause</button>`,
            `<button style='display:none;' class='btn btn-default x-big-end' data-role='end'>End tour</button>`,
            '</div>',
            '</div>',
            '</div>'
        ].join('\n');

        const me = {
            trackingObjectTourEnd: null,
            startDelay: 1000,
            go: function () {
                _.delay(function () {
                    me.tour.init();
                    me.tour.start();
                }, me.startDelay);
            },
            tourOptions: {
                storage: false,
                backdrop: false,
                closeButtonText: 'End Tour',
                steps: [],
                template: template,
                onNext: function () {

                    RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.V3NextPointTour);
                },
                onShown: function (t) {

                    const currentStepCount = (t && t._state ? t._state.current_step : null);
                    const lastStepCount = t._options.steps.length - 1;
                    let prevStep = null;

                    if (currentStepCount > 0) {

                        prevStep = me.tour._options.steps[me.tour._current - 1];

                        if (prevStep && prevStep.bodyClass) {
                            $('body').removeClass(prevStep.bodyClass);
                        }
                    }

                    const step = me.tour._options.steps[me.tour._current];
                    if (step && step.bodyClass) {
                        $('body').addClass(step.bodyClass);
                    }

                    if (currentStepCount === lastStepCount) {

                        const endButton = $('.popover.tour-tour button.x-big-end');
                        $('.popover.tour-tour button.x-big-next').hide();
                        endButton.html(me.tourOptions.closeButtonText);
                        endButton.show();
                        // usually if the user makes it to the end, we want to call that complete
                        // but for some tours we want to wait until they actually click the done button
                        if (!me.skipAutoEnd) {
                            me.updateSettings();
                        }
                    }

                    // less than for the check instead of equals as this method is called if the tour is
                    // open and the user resizes their browser; in that case, it's ok if the same tour
                    // step is executed multiple times.
                    if (me._expectedCurrentStep < currentStepCount) {
                        RivalIQ.errors.script.reportError([
                            'Skipped tour step',
                            window.location,
                            `tourId: ${me.tourId}`,
                            `stepNum: ${me._expectedCurrentStep}`
                        ].join('; '), new Error('Skipped Tour Step'));
                    }
                    me._expectedCurrentStep = currentStepCount + 1;

                    // set the counter; only show the counter if there's more than one step.
                    if (lastStepCount !== 0) {
                        $('.popover.tour-tour .step-counter').text(String(`${String(currentStepCount + 1)} of ${lastStepCount + 1}`));
                    }
                },

                onEnd: function () {
                    const step = me.tour._options.steps[me.tour._current];
                    if (step && step.bodyClass) {
                        $('body').removeClass(step.bodyClass);
                    }

                    if (config.onEnd) {
                        config.onEnd();
                    }
                },

                onStart: function () {
                    if (config.onStart) {
                        config.onStart();
                    }
                }
            },
            updateSettings: function () {
                const me = this;

                RivalIQ.state.user.completeTour(me.tourId);

                if (me.trackingObjectTourEnd) {

                    App.execute('tracking:push:auth', me.trackingObjectTourEnd);
                }
            }
        };

        config = _.resultingObject(me, config, options);
        _.extend(me, _.pick(config, 'tourId', 'trackingObjectTourEnd', 'startDelay', 'skipAutoEnd'));
        _.extend(me.tourOptions, _.pick(config, 'steps', 'closeButtonText', 'autoscroll', 'closeButtonText', 'container'));

        me._expectedCurrentStep = 0;
        me.tour = new Tour(me.tourOptions);

        return me;
    };

    let activeTour;
    tour.start = function (config, options) {
        if (RivalIQ.state.user.shouldShowTour(config.tourId)) {
            tour.end();
            activeTour = new tour.Tour(config, options);
            activeTour.go();
        }
    };

    tour.end = function () {

        if (activeTour && activeTour.tour) {
            activeTour.tour.end();
            // forced clean up in the case that the tour bubble selector isn't on page any more.
            // note that this will kill any ongoing tour bubbles, though we shouldn't have more
            // than one tour on a page.
            $('.popover.tour-tour').remove();
        }
        activeTour = null;

    };

    App.commands.setHandler('tour:start', tour.start);
    App.commands.setHandler('tour:end', tour.end);

}, window.Tour);
